import linegraph from '../../../../../components/linegraph.vue'
import * as echarts from "echarts"
import iTable from "../../../../../components/Table.vue";
import IPagination from "../../../../../components/pagination.vue";
import { domainName } from "../../../../../utility/index";
import moment from 'moment';

export default {
    props: ["bindCar"],
    data() {
        return {
            changeValue: [],
            optionLine: {},
            lineLoading: false,
            isLine: true,
            optionPie: {},
            pieLoading: false,
            orgId: '',
            formInline: {
                carId: '',
            },
            height: '500',
            list: [],
            option: {
                stripe: true,
                border: true,
                loading: false, 
                highlightCurrentRow: false, 
                mutiSelect: true, 
                serialNumber: true, 
            },
            columnsAll: [
                {
                    prop: "carId",
                    label: this.$t('VehicleAnalysis.carId'),
                    align: "center",
                },
                {
                    prop: "manufactureNum",
                    label: this.$t('VehicleAnalysis.manufactureNum'),
                    align: "center",
                    width: "150px"
                },
                {
                    prop: "customNum",
                    label: this.$t('VehicleAnalysis.customNum'),
                    align: "center",
                    width: "120px"
                },
                {
                    prop: "plateNum",
                    label: this.$t('VehicleAnalysis.plateNum'),
                    align: "center",
                    width: "120px"
                },
                {
                    prop: "orgName",
                    label: this.$t('VehicleAnalysis.orgName'),
                    align: "center",

                },
                {
                    prop: "stopCount",
                    label: this.$t('VehicleAnalysis.stopCount'),
                    align: "center",

                },
                {
                    prop: "lowLiquidLevelCount",
                    label: this.$t('VehicleAnalysis.lowLiquidLevelCount'),
                    align: "center",

                },
                {
                    prop: "lowOilCount",
                    label: this.$t('VehicleAnalysis.lowOilCount'),
                    align: "center",

                },
                {
                    prop: "lowPowerCount",
                    label: this.$t('VehicleAnalysis.lowPowerCount'),
                    align: "center",
                }
            ],
            columnsOne: [
                {
                    prop: "carId",
                    label: this.$t('VehicleAnalysis.carId'),
                    align: "center",
                },
                {
                    prop: "manufactureNum",
                    label: this.$t('VehicleAnalysis.manufactureNum'),
                    align: "center",
                    width: "150px"
                },
                {
                    prop: "customNum",
                    label: this.$t('VehicleAnalysis.customNum'),
                    align: "center",
                    width: "120px"
                },
                {
                    prop: "plateNum",
                    label: this.$t('VehicleAnalysis.plateNum'),
                    align: "center",
                    width: "120px"
                },
                {
                    prop: "terminalId",
                    label: this.$t('VehicleAnalysis.terminalId'),
                    align: "center",
                },
                {
                    prop: "orgName",
                    label: this.$t('VehicleAnalysis.orgName'),
                    align: "center",

                },
                {
                    prop: "endTime",
                    label: this.$t('VehicleAnalysis.problemTime'),
                    align: "center",

                },
                {
                    prop: "eventMessage",
                    label: this.$t('VehicleAnalysis.eventMessage'),
                    align: "center",
                }
            ],
            columns: [],
            operates: {
                width: 100,
                fixed: "right",
                list: [],
            },
            currentPage: 1,
            pageSize: 10,
            total: 1,
        }
    },
    components: {
        linegraph,
        iTable,
        IPagination
    },
    created() {
        this.getDate()
    },
    methods: {
        getDate() {
            const endTime = moment().subtract(1, "day").format("YYYY-MM-DD");
            const startTime = moment().subtract(1, "month").format("YYYY-MM-DD");
            this.changeValue = [startTime, endTime];
        },
        changeTime() {
            this.getFaultPeriod()
            this.getFaultMonth()
            this.getMonthOrderList('all')
        },
        initQuery(type) {
            this.type = type
            this.pageSize = 10
            this.currentPage = 1
            if (type == 'one') {
                this.columns = this.columnsOne
                this.getOneMonthOrderList()
            } else {
                this.columns = this.columnsAll
                this.getMonthOrderList()
            }
        },
        getFaultPeriod() {
            this.lineLoading = true
            let dateArr = [];
            let filterPlugging = [];
            let lowPower = [];
            let lowOil = [];
            let lowLiquid = [];
            let param = {
                orgId: Number(this.orgId),
                carId: this.carId,
                selectType: 1,
                startTime: this.changeValue[0],
                endTime: this.changeValue[1],
            }
            this.$store.dispatch("VehicleAnalysis/GET_QUERYFAULTCOUNTPERIOD", param).then(res => {
                if (res) {
                    if (res.data.code == 200) {
                        if (res.data.data.length > 0) {
                            this.isLine = true
                            res.data.data.map((item, index) => {
                                dateArr.push(item.workDatetime)
                                filterPlugging.push(item.filterPluggingCount)
                                lowPower.push(item.lowPowerCount)
                                lowOil.push(item.lowOilCount)
                                lowLiquid.push(item.lowLiquidCount)
                                this.FaultLine(dateArr, filterPlugging, lowPower, lowOil, lowLiquid)
                            })
                        } else {
                            this.isLine = false
                        }
                    }
                }
                this.lineLoading = false
            }).catch(err => {
                this.lineLoading = false
            })
        },
        FaultLine(dateArr, filterPlugging, lowPower, lowOil, lowLiquid) {
            let option = {
                tooltip: {
                    trigger: 'axis',
                },
                legend: {
                    left: 'center',
                    data: [this.$t('VehicleAnalysis.lowOilCount'), this.$t('VehicleAnalysis.lowPowerCount'), this.$t('VehicleAnalysis.lowLiquidLevelCount'), this.$t('VehicleAnalysis.airStop')],
                    top: '10',
                    textStyle: {
                        color: '#fff'
                    }
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    axisTick: {
                        show: false
                    },
                    axisLine: {
                        lineStyle: {
                            color: '#fff',
                        }
                    },
                    axisLabel: {
                        textStyle: {
                            color: '#fff',
                        }
                    },
                    splitLine: { show: false },
                    data: dateArr
                },
                grid: {
                    left: '1%',
                    right: '2%',
                    bottom: '3%',
                    containLabel: true
                },
                yAxis: [{
                    type: 'value',
                    name: this.$t('VehicleAnalysis.value'),
                    nameTextStyle: {
                        color: "white",
                    },
                    axisTick: {
                        show: false
                    },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            color: ['rgba(173,177,195,.1)'],
                            type: 'dashed'
                        }
                    },
                    axisLabel: {
                        formatter: '{value}',
                        color: '#fff'
                    }
                }],
                series: [
                    {
                        name: this.$t('VehicleAnalysis.lowOilCount'),
                        type: 'line',
                        smooth: true,
                        color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
                            offset: 0,
                            color: '#fc5a62'
                        }, {
                            offset: 1,
                            color: '#f69d70'
                        }]),
                        data: lowOil,
                    },
                    {
                        name: this.$t('VehicleAnalysis.lowPowerCount'),
                        type: 'line',
                        smooth: true,
                        color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
                            offset: 0,
                            color: '#437cfc'
                        }, {
                            offset: 1,
                            color: '#48e2f9'
                        }]),
                        data: lowPower,
                    },
                    {
                        name: this.$t('VehicleAnalysis.lowLiquidLevelCount'),
                        type: 'line',
                        smooth: true,
                        color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
                            offset: 0,
                            color: '#56d1a9'
                        }, {
                            offset: 1,
                            color: '#baeb46'
                        }]),
                        data: lowLiquid,
                    },
                    {
                        name: this.$t('VehicleAnalysis.airStop'),
                        type: 'line',
                        smooth: true,
                        color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
                            offset: 0,
                            color: '#8e70f9'
                        }, {
                            offset: 1,
                            color: '#da609f'
                        }]),
                        data: filterPlugging,
                    },
                ]
            }
            this.optionLine = option
        },

        getFaultMonth() {
            this.pieLoading = true
            let param = {
                orgId: Number(this.orgId),
                carId: this.carId,
                selectType: 1,
                startTime: this.changeValue[0],
                endTime: this.changeValue[1],
            }
            this.$store.dispatch("VehicleAnalysis/GET_QUERYFAULTCOUNTPERIODRATE", param).then(res => {
                if (res) {
                    if (res.data.code == 200) {
                        this.filterPlugging = res.data.data.filterPlugging.indexOf('%') > -1 ? res.data.data.filterPlugging.split('%')[0] : ""
                        this.lowPower = res.data.data.lowPower.indexOf('%') > -1 ? res.data.data.lowPower.split('%')[0] : ''
                        this.lowOil = res.data.data.lowOil.indexOf('%') > -1 ? res.data.data.lowOil.split('%')[0] : ''
                        this.lowLiquid = res.data.data.lowLiquidLevel.indexOf('%') > -1 ? res.data.data.lowLiquidLevel.split('%')[0] : ''
                        this.FaultPie(this.filterPlugging, this.lowPower, this.lowOil, this.lowLiquid)
                    }
                }
                this.pieLoading = false
            }).catch(err => {
                this.pieLoading = false
            })
        },
        FaultPie(filterPlugging, lowPower, lowOil, lowLiquid) {
            let option = {
                tooltip: {
                    trigger: 'item',
                    formatter: "{a} <br/>{b} : {c} ({d}%)"
                },
                legend: {
                    orient: 'vertical',
                    left: '5%',
                    top: 'center',
                    itemWidth: 10,  
                    itemHeight: 10, 
                    itemGap: 20,
                    textStyle: {
                        color: '#fff'
                    },
                    data: [this.$t('VehicleAnalysis.lowPowerCount'), this.$t('VehicleAnalysis.lowOilCount'), this.$t('VehicleAnalysis.lowLiquidLevelCount'), this.$t('VehicleAnalysis.airStop')]
                },
                series: [
                    {
                        name: this.$t('common.number'),
                        type: 'pie',
                        radius: ['45%', '65%'],
                        center: ['60%', '50%'],
                        data: [
                            { value: filterPlugging, name: this.$t('VehicleAnalysis.airStop') },
                            { value: lowOil, name: this.$t('VehicleAnalysis.lowOilCount') },
                            { value: lowPower, name: this.$t('VehicleAnalysis.lowPowerCount') },
                            { value: lowLiquid, name: this.$t('VehicleAnalysis.lowLiquidLevelCount') },
                        ],
                        label: {
                            color: '#fff'
                        },
                        itemStyle: {
                            normal: {
                                color: function (params) {
                                    var colorList = [
                                        ['#fc5a62', '#f69d70'],
                                        ['#437cfc', '#48e2f9'],
                                        ['#56d1a9', '#baeb46'],
                                        ['#8e70f9', '#da609f'],
                                    ];
                                    return new echarts.graphic.LinearGradient(0, 0, 0, 1,

                                        [
                                            { offset: 0, color: colorList[params.dataIndex][0] },
                                            { offset: 1, color: colorList[params.dataIndex][1] }
                                        ]);
                                },
                            }

                        }
                    }
                ]
            }
            this.optionPie = option
        },

        getMonthOrderList() {
            let param = {
                orgId: this.orgId,
                pageNum: this.currentPage,
                pageSize: this.pageSize,
                selectType: 1,
                startTime: this.changeValue[0],
                endTime: this.changeValue[1],
            };
            this.$store.dispatch('VehicleAnalysis/GET_QUERYFAULTPAGEBYCAR', param).then(res => {
                if (res) {
                    if (res.data.code == 200) {
                        this.list = res.data.data.list
                        this.$refs.page.CommandTotal = res.data.data.total
                    }
                }
            }).catch(err => { })
        },
        getOneMonthOrderList() {
            let param = {
                orgId: this.orgId,
                pageNum: this.currentPage,
                pageSize: this.pageSize,
                selectType: 1,
                carId: this.carId,
                startTime: this.changeValue[0],
                endTime: this.changeValue[1],
            };
            this.$store.dispatch('VehicleAnalysis/GET_QUERYFAULTPAGEBYCAR', param).then(res => {
                if (res) {
                    if (res.data.code == 200) {
                        this.list = res.data.data.list
                        this.$refs.page.CommandTotal = res.data.data.total
                    }
                }
            }).catch(err => { })
        },
        downCar() {
            if (this.type == 'one') {
                if (domainName) {
                    if (domainName.split(':')[0] !== 'localhost') {
                        let url = `https://${domainName}/v1/getExportExcel/fault/uploadFaultPageByCar?orgId=${this.orgId}&selectType=${1}&carId=${this.bindCar}&startTime=${this.changeValue[0]}&endTime=${this.changeValue[1]}`
                        location.href = url
                    } else {
                        let host = 'localhost:8080'
                        let url = `https://${host}/v1/getExportExcel/fault/uploadFaultPageByCar?orgId=${this.orgId}&selectType=${1}&carId=${this.bindCar}&startTime=${this.changeValue[0]}&endTime=${this.changeValue[1]}`
                        location.href = url
                    }
                }
            } else {
                if (domainName) {
                    if (domainName.split(':')[0] !== 'localhost') {
                        let url = `https://${domainName}/v1/getExportExcel/fault/uploadFaultPageByCar?orgId=${this.orgId}&selectType=${1}&startTime=${this.changeValue[0]}&endTime=${this.changeValue[1]}`
                        location.href = url
                    } else {
                        let host = 'localhost:8080'
                        let url = `https://${host}/v1/getExportExcel/fault/uploadFaultPageByCar?orgId=${this.orgId}&selectType=${1}&startTime=${this.changeValue[0]}&endTime=${this.changeValue[1]}`
                        location.href = url
                    }
                }
            }
            
        },
        handleSelectionChange(val) {
            this.selected = val
        },
        changeSize(item) {
            this.pageSize = item.pageSize
            this.currentPage = item.pageNum
            if (this.type == 'one') {
                this.columns = this.columnsOne
                this.getOneMonthOrderList()
            } else {
                this.columns = this.columnsAll
                this.getMonthOrderList()
            }
        },
    }
}
